import { qs, qsa, on, delegate, trimFields } from '../lib/dom.js';
import { t } from '../lib/i18n.js';
import { initValuation } from '../components/valuation.js';

export function initEvaluarePage() {
  // Instant-price valuation block (nomermd-proxied). Independent of the lead
  // form below, so init it first, then wire the lead form if present.
  initValuation();

  const form = qs('[data-component="evaluare-form"]');
  if (!form) return;

  // 3-pill "stare" radiogroup - single select
  delegate(form, 'click', '[data-state]', (e, btn) => {
    qsa('[data-state]', form).forEach((b) => {
      const active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-checked', String(active));
    });
  });

  on(form, 'submit', async (e) => {
    e.preventDefault();
    // See trimFields(): `required` accepts a lone Space, so normalise first.
    trimFields(form);
    if (!form.checkValidity()) {
      const bad = form.querySelector(':invalid');
      if (bad && bad.focus) bad.focus();
      return;
    }
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add('is-loading');

    // Post the lead to the REST endpoint (form.action = /autoplaza/v1/evaluare).
    // Include the selected "stare" pill (buttons, not inputs) when present.
    const fd = new FormData(form);
    const activePill = form.querySelector('[data-state].is-active');
    if (activePill) fd.set('state', activePill.dataset.state || '');

    let ok = true;
    try {
      const res = await fetch(form.action, { method: 'POST', credentials: 'same-origin', body: fd });
      ok = res.ok;
    } catch { ok = false; }
    if (btn) btn.classList.remove('is-loading');
    if (!ok) return; // leave the form so the visitor can retry

    form.reset();
    // Same confirmation pattern + styles as every other lead form.
    const done = form.parentElement && form.parentElement.querySelector('[data-role="lead-done"]');
    if (done) { form.hidden = true; done.hidden = false; }
  });
}
